const SOCIAL_MEDIA_PLATFORM_IDS = {
    FACEBOOK: 1,
    INSTAGRAM: 2,
    TWITTER: 3,
    TIKTOK: 7,
    LINKEDIN: 8,
};
export { SOCIAL_MEDIA_PLATFORM_IDS };
